<template>
    <!-- TODO css -->
    <modal @close="modals.batchDetailModal = false">
        <div v-if="screen === 'form'">
            <h3>List Detail</h3>
            <div class="large-form">
                <div class="form-line">
                    <div class="form-field" style="width: 100%">
                        <label for="form-input-name">List Name</label>
                        <div class="form-static-field" v-if="!rename"><b>{{ batch.label }}</b></div>
                        <span class="ws-button small" style="float: left" @click="rename = true" v-if="!rename" >Change Name</span>
                        <input v-model="batch.label" v-if="rename" />
                    </div>
                </div>                
                
                <div class="form-line">
                    <div class="form-field" style="width: 70%">
                        <label for="form-input-name">Created At</label>
                        <div class="form-static-field">{{ batch.created }}</div>
                    </div>
                    <div class="form-field" style="width: 30%">
                        <label for="form-input-name">Method</label>
                        <div class="form-static-field">{{ batch.method == 'multiple'?'Multi Send':'Multi Link'}}</div>
                    </div>
                </div>
                
                <div class="form-line">
                    <div class="form-field" style="width: 100%">
                        <label for="form-input-name">List Gift Claim Link</label>
                        <div class="form-static-field" style="font-size: 13px; line-height: 21px; width: 100%;"><a :href="batchLink" target="_blank">{{ batchLink }}</a></div>
                    </div>
                </div>
                
                <div class="form-line">
                    <div class="form-field" style="width: 100%">
                        <label for="form-input-name">List Stats</label>
                        <div class="form-static-field">
                            <table style="width: 100%; font-size: 14px; line-height: 24px;">
                                <tr>
                                    <td>Gift registered</td>
                                    <td><b>{{ batch.registered }} / {{ batch.total }}</b></td>
                                    <td>{{ Math.round((batch.registered / batch.total)*100) }}%</td>
                                </tr>
                                <tr>
                                    <td>Confirmed orders</td>
                                    <td><b>{{ batch.confirmed }} / {{ batch.total }}</b></td>
                                    <td>{{ Math.round((batch.confirmed / batch.total)*100) }}%</td>
                                </tr>
                                <tr>
                                    <td>Processed & Sent</td>
                                    <td><b>{{ batch.sent }} / {{ batch.total }}</b></td>
                                    <td>{{ Math.round((batch.sent / batch.total)*100) }}%</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-actions">
              <span class="ws-button ws-button-secondary" data-action="cancel" @click="modals.batchDetailModal = false">Close</span>
              <span class="ws-button ws-button-main" @click="addMore" v-if="campaign.type=='sales' && location=='campaign'">Add More Leads</span>
              <span class="ws-button ws-button-main" @click="addMore" v-else-if="location=='campaign'" >Add More To This List</span>
              <span class="ws-button ws-button-main" @click="renameBatch" v-if="rename">Save Changes</span>
            </div>
        </div>
        
        <!-- Loading -->
        <div v-else-if="screen === 'loading'">
            <div class="ws-form-processing"><div class="value-loader"></div><p>We're retrieving the batch details. <br>Please give us a moment...</p></div>
        </div>
    </modal>
</template>

<script>
import Modal from "@/components/modals/Modal";

export default {
    name: "BatchDetailModal",
    components: {Modal},
    props: {
        campaignId: Number,
        batchId: String,
        batchLink: String,
        location: String,
    },
    data() {
        return {
            batch: {},
            screen: 'loading',
            rename: false,
        }
    },
    methods: {
        async renameBatch() {
            if (!this.demoCheck()) return;
            
            await this.dispatchWaitAndNotify('updateBatch', {data: {campaignId: this.campaignId, sharedSecret: this.batchId}, payload: {label: this.batch.label}});
            this.rename = false;
            this.$emit('batch-renamed', this.batch);
        },
        addMore() {
            this.$emit('add-more', this.batch);
        },
    },
    async mounted() {
        this.batch = await this.dispatchWaitAndNotify('fetchBatchDetails', {campaignId: this.campaignId, sharedSecret: this.batchId}, false, true);
        this.screen = 'form';
    },
    computed: {
        campaign() {
            return this.$store.state.giftBoxCampaign.detail;
        },
        team() {
            return this.$store.state.team.detail;
        },
        modals() {
            return this.$store.state.modals;
        },
    }
}
</script>

<style scoped>

</style>